// @ts-ignore
import { checkIsArrayEmpty as _checkIsArrayEmpty } from "@my-scoot/exly-react-component-lib/build/esm/utils/common/dataTypes/array";
import type { checkIsArrayEmpty as checkIsArrayEmptyType } from "@my-scoot/exly-react-component-lib/build/types/utils/common/dataTypes/array";

export const checkIsArrayEmpty: typeof checkIsArrayEmptyType =
  _checkIsArrayEmpty;
